export default "__VITE_ASSET__2480e6af__"